import React from 'react';
export var RadioGroupContext = /*#__PURE__*/React.createContext({
  activeItem: undefined,
  onSelect: function onSelect() {
    return undefined;
  },
  name: '',
  disabled: undefined,
  error: undefined,
  warning: undefined
});
RadioGroupContext.displayName = 'RadioGroupContext';